// src/components/Pagination.js
import React from 'react';
import { Paginator } from 'primereact/paginator';
import 'primereact/resources/primereact.min.css';

const Pagination = ({ 
  first, 
  rows, 
  totalRecords, 
  onPageChange, 
  currentPage,
  loading 
}) => {
  // Don't show pagination if loading or only one page
  if (loading || totalRecords <= rows) return null;

  return (
    <div className="pagination-container">
      <Paginator
        first={first}
        rows={rows}
        totalRecords={totalRecords}
        onPageChange={onPageChange}
        rowsPerPageOptions={[10, 15, 20, 30]}
        template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
      />
      <div className="pagination-info">
        Page {currentPage} of {Math.ceil(totalRecords / rows)} | 
        Showing {Math.min(rows, totalRecords - first)} of {totalRecords} items
      </div>
    </div>
  );
};

export default Pagination;